import { ActivityUser } from "@adsk/alloy-react-activity-log";
import React from "react";
import {
  useCompaniesEntitiesMapByOxygenId,
  useRolesEntitiesMapByOxygenId,
} from "@adsk/acc-issues-common/hooks/data/projectMembersHooks";
import { ActivityLogCardProps } from "../activityLogTypes";
import { ChangedValueActivityCard } from "./ChangedValueActivityCard";
import { useGetProjectActorByOxygenId } from "../../../hooks/useGetProjectActorByOxygenId";

export const ChangedAssigneeActivityCard = ({
  activityChange,
  ...props
}: ActivityLogCardProps) => {
  const companiesMap = useCompaniesEntitiesMapByOxygenId();
  const rolesMap = useRolesEntitiesMapByOxygenId();
  const getUserInfo = useGetProjectActorByOxygenId();
  const getUser = (key: string) => {
    const userData = getUserInfo(key);
    const userInfo = userData?.name ? userData : null;
    return companiesMap[key] || rolesMap[key] || userInfo;
  };
  const { before, after } = activityChange;
  const beforeUser = before ? getUser(before) : undefined;
  const afterUser = after ? getUser(after) : undefined;

  return (
    <ChangedValueActivityCard
      {...props}
      activityChange={{
        ...activityChange,
        before: beforeUser,
        after: afterUser,
      }}
      getDisplayText={user => <ActivityUser user={user} />}
    />
  );
};
